import { IPagedResultsV1 } from '@gcl/react-core';
import { apiServerGet } from '@common/axios.services';
import { envConfigs } from '@config/envConfigs';
import { IApiBaseProps } from '@common/api.models';
import { IMobileActionUsage, IProjectLoadingRemovalCertChecklistCount } from './report.models';

export const apiRoutes = {
  loadingRemovalCertsMobileActionUsage: '/LoadingRemovalCerts/MobileActionUsage',
  loadingRemovalCertsChecklistsCount: '/LoadingRemovalCerts/Checklists/Count',
};

export const getLoadingRemovalCertsChecklistsCountAsync = async (): Promise<
  IPagedResultsV1<IProjectLoadingRemovalCertChecklistCount>
> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectLoadingRemovalCertChecklistCount>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.loadingRemovalCertsChecklistsCount}`,
  );
  return result.data;
};

export const getLoadingRemovalCertsMobileActionUsageAsync = async (
  props: IApiBaseProps,
): Promise<IPagedResultsV1<IMobileActionUsage>> => {
  const result = await apiServerGet<IPagedResultsV1<IMobileActionUsage>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.loadingRemovalCertsMobileActionUsage}`,
    {
      params: props,
    },
  );
  return result.data;
};
